// Envoltorio de `window.location.assign`: jsdom no navega, así que los tests reemplazan
// este módulo en vez de pelear con `window.location`.
export function irA(url) {
  window.location.assign(url);
}

// Igual, pero reemplaza la entrada del historial (`location.replace`): para mandar a otra sección a quien llegó a
// una que no es suya, sin que "atrás" lo devuelva al mismo callejón.
export function reemplazarCon(url) {
  window.location.replace(url);
}
